import { render, staticRenderFns } from "./helpdesk.vue?vue&type=template&id=13f74edb&"
import script from "./helpdesk.vue?vue&type=script&lang=js&"
export * from "./helpdesk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports